import {
    FETCH_ASSETPRICING_BEGIN,
    FETCH_ASSETPRICING_SUCCESS,
    FETCH_ASSETPRICING_FAILURE
} from '../constants/pricing';

const initialState = {
    AssetpricingList: [],
    isLoading: false,
    isPricingLoading:false,
    error: ""
}


export const getAssetPricingReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ASSETPRICING_BEGIN: {
            return {
                ...state,
                isLoading: true,
                isPricingLoading: true,
                error: null,
            };
        }
        case FETCH_ASSETPRICING_FAILURE:
            return {
                ...initialState,
                isLoading: true,
                isPricingLoading: false,
                AssetpricingList: null
            };
        case FETCH_ASSETPRICING_SUCCESS:
            return {
                ...initialState,
                AssetpricingList: payload.AssetpricingList,
                isPricingLoading: false,
                isLoading: false,
            };
        default:
            return state;
    }
}

export default getAssetPricingReducer
